import api from '../Api';

export const fetchBusinesses = async filterStatus => {
  try {
    const response = await api.get('/admin/business', {
      params: { status: filterStatus === 'all' ? undefined : filterStatus },
    });

    return Array.isArray(response.data)
      ? response.data.map(app => ({
          ...app,
          imageUrl: app.profilePic || '',
          address: Array.isArray(app.address) ? app.address.join(', ') : app.address || 'N/A',
        }))
      : [];
  } catch (error) {
    console.error('Error fetching businesses:', error);
    throw error;
  }
};

export const deleteBusiness = async businessId => {
  try {
    await api.delete(`/admin/${businessId}`);
    return true;
  } catch (error) {
    console.error('Error deleting business:', error);
    throw error;
  }
};

export const deactivateBusiness = async businessId => {
  const response = await api.patch(`/admin/status/${businessId}/disable`);
  return response.data;
};

export const reactivateBusiness = async businessId => {
  const response = await api.patch(`/admin/status/${businessId}/active`);
  return response.data;
};

export const viewBusiness = (navigate, businessId) => {
  navigate(`/business/list/${businessId}`);
};
